import MatrixVisualization from '@/features/LegacyBenchmarksUI/components/MatrixVisualization';
import RankedList from '@/features/LegacyBenchmarksUI/components/RankedList';
import { useAssessment } from '@/contexts/AssessmentContext';
import AssessmentActionButtons from '@/features/LegacyBenchmarksUI/components/assessment/AssessmentActionButtons';

const Index = () => {
  const { weights, scoredOpportunities } = useAssessment();

  return (
    <div className="container mx-auto px-4 py-8 max-w-[1400px] space-y-8">
      <div className="mb-6">
        <AssessmentActionButtons 
          weights={weights}
          scoredOpportunities={scoredOpportunities}
          isEditing={false}
        />
      </div>
      <MatrixVisualization />
      <RankedList />
    </div>
  );
};

export default Index;